module.exports = __webpack_public_path__ + "img/tk.63124ade.png";